export const PERFORMANCEPROGRESS = [
    {
        header: "รวมทุกกลุ่มอาหาร",
        accessorKey: "performanceProgress",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "",
        accessorKey: "quantity",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ม.ค.",
        accessorKey: "January",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.พ.",
        accessorKey: "February",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "มี.ค.",
        accessorKey: "March",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "เม.ย.",
        accessorKey: "April",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "พ.ค.",
        accessorKey: "May",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "มิ.ย.",
        accessorKey: "June",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.ค.",
        accessorKey: "July",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ส.ค.",
        accessorKey: "August",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.ย.",
        accessorKey: "September",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ต.ค.",
        accessorKey: "October",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "พ.ย.",
        accessorKey: "November",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ธ.ค.",
        accessorKey: "December",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "สะสม (2022)",
        accessorKey: "total",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
]

export const PERFORMANCECHICKENEGG = [
    {
        header: "อาหารไก่ไข่",
        accessorKey: "performanceProgress",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "",
        accessorKey: "quantity",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ม.ค.",
        accessorKey: "January",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.พ.",
        accessorKey: "February",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "มี.ค.",
        accessorKey: "March",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "เม.ย.",
        accessorKey: "April",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "พ.ค.",
        accessorKey: "May",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "มิ.ย.",
        accessorKey: "June",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.ค.",
        accessorKey: "July",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ส.ค.",
        accessorKey: "August",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.ย.",
        accessorKey: "September",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ต.ค.",
        accessorKey: "October",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "พ.ย.",
        accessorKey: "November",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ธ.ค.",
        accessorKey: "December",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "สะสม (2022)",
        accessorKey: "total",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
]

export const PERFORMANCECHICKENMEAT = [
    {
        header: "อาหารไก่เนื้อ",
        accessorKey: "performanceProgress",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "",
        accessorKey: "quantity",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ม.ค.",
        accessorKey: "January",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.พ.",
        accessorKey: "February",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "มี.ค.",
        accessorKey: "March",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "เม.ย.",
        accessorKey: "April",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "พ.ค.",
        accessorKey: "May",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "มิ.ย.",
        accessorKey: "June",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.ค.",
        accessorKey: "July",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ส.ค.",
        accessorKey: "August",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.ย.",
        accessorKey: "September",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ต.ค.",
        accessorKey: "October",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "พ.ย.",
        accessorKey: "November",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ธ.ค.",
        accessorKey: "December",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "สะสม (2022)",
        accessorKey: "total",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
]

export const PERFORMANCEPORK = [
    {
        header: "อาหารสุกร (รวม)",
        accessorKey: "performanceProgress",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "",
        accessorKey: "quantity",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ม.ค.",
        accessorKey: "January",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.พ.",
        accessorKey: "February",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "มี.ค.",
        accessorKey: "March",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "เม.ย.",
        accessorKey: "April",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "พ.ค.",
        accessorKey: "May",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "มิ.ย.",
        accessorKey: "June",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.ค.",
        accessorKey: "July",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ส.ค.",
        accessorKey: "August",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.ย.",
        accessorKey: "September",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ต.ค.",
        accessorKey: "October",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "พ.ย.",
        accessorKey: "November",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ธ.ค.",
        accessorKey: "December",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "สะสม (2022)",
        accessorKey: "total",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
]

export const PERFORMANCEBEEF = [
    {
        header: "อาหารวัว",
        accessorKey: "performanceProgress",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "",
        accessorKey: "quantity",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ม.ค.",
        accessorKey: "January",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.พ.",
        accessorKey: "February",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "มี.ค.",
        accessorKey: "March",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "เม.ย.",
        accessorKey: "April",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "พ.ค.",
        accessorKey: "May",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "มิ.ย.",
        accessorKey: "June",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.ค.",
        accessorKey: "July",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ส.ค.",
        accessorKey: "August",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.ย.",
        accessorKey: "September",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ต.ค.",
        accessorKey: "October",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "พ.ย.",
        accessorKey: "November",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ธ.ค.",
        accessorKey: "December",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "สะสม (2022)",
        accessorKey: "total",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
]

export const PERFORMANCEOTHERS = [
    {
        header: "อาหารอื่น ๆ",
        accessorKey: "performanceProgress",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "",
        accessorKey: "quantity",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ม.ค.",
        accessorKey: "January",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.พ.",
        accessorKey: "February",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "มี.ค.",
        accessorKey: "March",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "เม.ย.",
        accessorKey: "April",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "พ.ค.",
        accessorKey: "May",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "มิ.ย.",
        accessorKey: "June",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.ค.",
        accessorKey: "July",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ส.ค.",
        accessorKey: "August",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ก.ย.",
        accessorKey: "September",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ต.ค.",
        accessorKey: "October",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "พ.ย.",
        accessorKey: "November",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "ธ.ค.",
        accessorKey: "December",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
    {
        header: "สะสม (2022)",
        accessorKey: "total",
        disableFilters: true,
        sticky: "left",
        size: 40,
        muiTableHeadCellProps: { sx: { backgroundColor: 'rgb(33, 87, 50)', color: 'white', fontSize: '12px' } }
    },
]